export default __webpack_public_path__ + "static/media/banner1.eaa5c7b1.jpg";